import AuthRepository from './AuthRepository';
import UserRepository from './UserRepository';
import RoleRepository from './RoleRepository';
import ImageRepository from './ImageRepository';
import ContactRepository from './ContactRepository';
import ContactStatusRepository from './ContactStatusRepository';
import AppointmentRespository from './AppointmentRespository';
import CallCenterRespository from './CallCenterRespository';
import OrderRepository from './OrderRepository';
import SchoolLevelRepository from './SchoolLevelRepository';
import CoreActionsLog from './CoreActionLogRepository';
import DashboardPartner from './DashboardPartnerRepository';
import TypeRepository from './TypeRepository';
import ChatbotRepository from './ChatbotRepository';
import ProductRepository from './ProductRepository';
import PromotionRepository from './PromotionRepository';
import CampaignRepository from './CampaignRepository';

const repositories = {
  auth: AuthRepository,
  user: UserRepository,
  role: RoleRepository,
  image: ImageRepository,
  contact: ContactRepository,
  contact_status: ContactStatusRepository,
  appointment: AppointmentRespository,
  call_center: CallCenterRespository,
  order: OrderRepository,
  school_level: SchoolLevelRepository,
  core_actions_log: CoreActionsLog,
  dashboard_partner: DashboardPartner,
  type: TypeRepository,
  chatbot: ChatbotRepository,
  product: ProductRepository,
  promotion: PromotionRepository,
  campaign: CampaignRepository,
};

export default {
  get: (name) => repositories[name],
};
